// import { html, nothing } from 'lit';
// import { api, constants } from '@converse/headless';
// import { __ } from 'i18n';
// import { getChatStyle } from 'shared/chat/utils';

// const { CHATROOMS_TYPE } = constants;

// /**
//  * @param {import('../chat').default} el
//  */
// export default (el) => {
//     const help_messages = el.getHelpMessages();
//     const show_help_messages = el.model.get('show_help_messages');
//     const is_overlayed = api.settings.get('view_mode') === 'overlayed';
//     const style = getChatStyle(el.model);
//     const show_drop_confirmation = el.model.get('show_drop_confirmation');
//     return html`
//         <div class="flyout box-flyout" style="${style || nothing}">
//             ${is_overlayed ? html`<converse-dragresize></converse-dragresize>` : ''}
//             ${el.model
//                 ? html`
//                       <converse-chat-heading
//                           jid="${el.model.get('jid')}"
//                           class="chat-head chat-head-chatbox row g-0"
//                       ></converse-chat-heading>
//                       <div class="chat-body">
//                           ${el.model.contact
//                               ? html`<converse-contact-approval-alert .contact="${el.model.contact}">
//                                 </converse-contact-approval-alert>`
//                               : ''}
//                           <div
//                               class="chat-content ${el.model.get('show_send_button') ? 'chat-content-sendbutton' : ''}"
//                               aria-live="polite"
//                               @dragover="${(ev) => {
//                                 ev.preventDefault();
//                                 ev.dataTransfer.dropEffect = 'copy';
//                             }}"
//                             @dragenter="${(ev) => ev.preventDefault()}"
//                             @drop="${/** @param {DragEvent} ev */ (ev) => {
//                                 ev.preventDefault();
//                                 el.onDrop(ev);
//                             }}"
//                           >
//                               <converse-chat-content .model="${el.model}"></converse-chat-content>
//                               ${show_help_messages
//                                   ? html`<div class="chat-content__help">
//                                         <converse-chat-help
//                                             .model=${el.model}
//                                             .messages=${help_messages}
//                                             ?hidden=${!show_help_messages}
//                                             type="info"
//                                             chat_type="${CHATROOMS_TYPE}"
//                                         ></converse-chat-help>
//                                     </div>`
//                                   : ''}
//                           </div>
//                           <converse-chat-bottom-panel .model="${el.model}" class="bottom-panel">
//                           </converse-chat-bottom-panel>
//                       </div>
//                   `
//                 : ''}
//         </div>
//     `;
// };

import { html, nothing } from 'lit';
import { api, constants } from '@converse/headless';
import { __ } from 'i18n';
import { getChatStyle } from 'shared/chat/utils';
import { isSelectingMessages } from 'shared/chat/selection.js';
import renderSelectionBar from 'shared/chat/templates/selection-bar.js';

const { CHATROOMS_TYPE } = constants;

export default (el) => {
    const help_messages = el.getHelpMessages();
    const show_help_messages = el.model.get('show_help_messages');
    const show_drop_confirmation = el.model.get('show_drop_confirmation');
    const is_overlayed = api.settings.get('view_mode') === 'overlayed';
    const style = getChatStyle(el.model);
    const is_selecting = isSelectingMessages(el.model);

    return html`<div class="flyout box-flyout" style="${style || nothing}" @dragover="${(e) => {
                e.preventDefault();
                e.stopPropagation(); // Остановка всплытия
                e.dataTransfer.dropEffect = 'copy';
            }}" @dragenter="${(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}" @drop="${(e) => {
                e.preventDefault();
                e.stopPropagation(); // Это не даст textarea внутри обработать файл
                el.onDrop(e);
            }}">${is_overlayed ? html`<converse-dragresize></converse-dragresize>` : ''} ${el.model
                ? html`<converse-chat-heading jid="${el.model.get('jid')}" class="chat-head chat-head-chatbox row g-0"></converse-chat-heading><div class="chat-body">${el.model.contact
                              ? html`<converse-contact-approval-alert .contact="${el.model.contact}"></converse-contact-approval-alert>`
                              : ''}<div class="chat-content ${el.model.get('show_send_button') ? 'chat-content-sendbutton' : ''}" aria-live="polite"><converse-chat-content .model="${el.model}"></converse-chat-content>${show_help_messages
                                  ? html`<div class="chat-content__help"><converse-chat-help .model="${el.model}" .messages="${help_messages}" ?hidden="${!show_help_messages}" type="info" chat_type="${CHATROOMS_TYPE}"></converse-chat-help></div>`
                                  : ''}</div>${is_selecting
                              ? renderSelectionBar(el.model)
                              : html`<converse-chat-bottom-panel .model="${el.model}" class="bottom-panel"></converse-chat-bottom-panel>`}</div>${show_drop_confirmation
                          ? html`<div class="custom-modal-overlay" @click="${() => el.closeDropConfirmation()}"><div class="custom-modal-card" @click="${(e) => e.stopPropagation()}"><div class="custom-modal-header"><h5 class="custom-modal-title">${__('Надіслати файли?')}</h5></div><div class="custom-modal-body"><p>${__('Бажаєте надіслати ці файли в цей чат?')}</p><ul class="custom-file-list">${Array.from(el.pendingFiles || []).map(
                                                    (f) => html`<li><strong>${f.name}</strong></li>`,
                                                )}</ul></div><div class="custom-modal-footer"><button class="btn btn-secondary" @click="${() => el.closeDropConfirmation()}">${__('Скасувати')}</button> <button class="btn btn-primary" @click="${() => el.confirmFileSend()}">${__('Надіслати')}</button></div></div></div>`
                          : ''}`
                : ''}</div>`;
};
